import { showToast } from '../shared/toast';

export function supportsNativeShare(): boolean {
  return typeof navigator.share === 'function' && window.matchMedia('(pointer: coarse)').matches;
}

export function isShareCancellation(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

export default function shareBlock(root: HTMLElement): void {
  const shareUrl = root.dataset.shareUrl || window.location.href;
  const nativeShareLink = root.querySelector<HTMLAnchorElement>('[data-native-share="true"]');

  nativeShareLink?.addEventListener('click', async event => {
    if (!supportsNativeShare()) return;

    event.preventDefault();

    try {
      await navigator.share({ url: shareUrl });
    } catch (error) {
      if (isShareCancellation(error)) return;

      console.error('[share-block] Native sharing failed', error);
    }
  });

  const copyButton = root.querySelector<HTMLButtonElement>('.share-block__copy-link');
  if (!copyButton) return;

  copyButton.addEventListener('click', () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => showToast('Link copied', { variant: 'neutral' }))
      .catch(() => showToast("Couldn't copy link", { variant: 'critical' }));
  });
}
